const warrantyFormInterval = setInterval(function() {
	if (document.querySelector("#app-embed") && document.querySelector("#app-embed").shadowRoot && document.querySelector("#app-embed").shadowRoot.querySelector("input[id$=product_name]")) {
		document.querySelector("#app-embed").shadowRoot.querySelector("input[id$=product_name]").setAttribute('readonly', 'readonly')
        const products = {
            "WV210ID": "Shark EvoPower",
            "WD210ID": "Shark Hydrovac Pro XL",
            "CS150IDAE": "Shark Evo Power System Ursa Auto Empty Dock",
            "CS601|DBL": "Shark Evo Power System Adv",
            "CS851IDMVAE": "Shark Evo Power System IQ+ Auto-Empty Dock",
            "IW2241ID": "Shark CleanSense iQ",
            "IW3241ID": "Shark CleanSense iQ+ Auto-Empty Dock",
            "HD436BR": "Shark FlexStyle - Full Package Mocha",
            "HD436SL": "Shark FlexStyle - Full Package Stone",
            "HD331ID": "Shark SpeedStyle",
            "AF300|D": "Ninja Dual Zone Air Fryer",
            "AG551ID": "Ninja Foodi Smart XL Grill & Air Fryer",
            "C|1001D": "Ninja Foodi Power Mixer System",
            "BN300ID": "Ninja Nutri SS blender Plus",
            "CB3501D": "Ninja Nutri Ninja Smart Power-Up Ultra-Speed Blender",
            "NC3001D": "Ninja Creami Ice Cream Maker",
            "BC151|D": "Ninja Blast Cordless Blender White"
        }

        const articleCode = document.querySelector("#app-embed").shadowRoot.querySelector("input[id$=article_code]").value
        if (articleCode && products[articleCode]) {
            document.querySelector("#app-embed").shadowRoot.querySelector("label[id$=product_name]").style.transform = "var(--input-label-transform)"
            document.querySelector("#app-embed").shadowRoot.querySelector("[id$=product_name]").value = products[articleCode]
        }
        else {
            document.querySelector("#app-embed").shadowRoot.querySelector("label[id$=product_name]").style.transform = "none"
            document.querySelector("#app-embed").shadowRoot.querySelector("[id$=product_name]").value = ""
        }
	}
}, 500)